module.exports = __webpack_public_path__ + "img/salerIcon.3d25d08d.png";